<script setup lang="ts">
import Icon from './Icon.vue';
import {inject,ref} from 'vue';
const theme=inject('fuqi-account-theme',ref(document.documentElement.dataset.theme || 'account'));
defineProps<{ message: string; kind: 'success' | 'error' | 'loading' | 'info' }>();
</script>
<template><Teleport to="body"><div class="fuqi-account-root" :data-theme="theme"><Transition name="toast"><div v-if="message" class="status-toast" :class="kind">
  <Icon :name="{ success: 'CheckCircle2', error: 'X', loading: 'LoaderCircle', info: 'Info' }[kind]" :class="{ spin: kind === 'loading' }" />
  <span>{{ message }}<span v-if="kind === 'loading'" class="loading-dots"><i>.</i><i>.</i><i>.</i></span></span>
</div></Transition></div></Teleport></template>
